import { Collections, Protest } from "api";
import { useCollection } from "api/hooks/useCollection";
import { WhereOptions } from "react-redux-firebase";

interface InvolvedProtestsOptions {
    userId: string;
    limit?: number;
    roundId?: string;
    initialDate?: string;
    finalDate?: string;
}

export const useInvolvedProtests = (
    options: InvolvedProtestsOptions
): Protest[] => {
    const { userId, limit, roundId, initialDate, finalDate } = options;
    const myProtestsWhere: WhereOptions[] = [["authorUserId", "==", userId]];
    const protestsWithMeWhere: WhereOptions[] = [
        ["protestedUserId", "==", userId],
    ];

    if (roundId) {
        myProtestsWhere.push(["roundId", "==", roundId]);
        protestsWithMeWhere.push(["roundId", "==", roundId]);
    }

    if (initialDate) {
        myProtestsWhere.push(["createdAt", ">=", initialDate]);
        protestsWithMeWhere.push(["createdAt", ">=", initialDate]);
    }

    if (finalDate) {
        myProtestsWhere.push(["createdAt", "<=", finalDate]);
        protestsWithMeWhere.push(["createdAt", "<=", finalDate]);
    }

    const myProtests =
        useCollection<Protest[]>(
            {
                collection: Collections.PROTESTS,
                where: myProtestsWhere,
                limit,
                storeAs: `myProtests${roundId || ""}`,
            },
            true
        ) || [];
    const protestsWithMe =
        useCollection<Protest[]>(
            {
                collection: Collections.PROTESTS,
                where: protestsWithMeWhere,
                limit,
                storeAs: `protestsWithMe${roundId || ""}`,
            },
            true
        ) || [];

    return [...myProtests, ...protestsWithMe];
};
